import { Radio, WifiOff } from 'lucide-react';
import { useDatos } from '../state/Datos';
import { fmtHoraSeg } from '../util/format';
import { useAhora } from '../util/hooks';

/** Indicador de la conexión del stream: En vivo / Reconectando, con la última actualización. */
export function EstadoEnVivo({ mostrarActualizacion = true }: { mostrarActualizacion?: boolean }) {
  const { conexion, ultimaActualizacion } = useDatos();
  useAhora(5000);
  const vivo = conexion === 'conectado';
  return (
    <div className="live" role="status" aria-live="polite">
      <span className={`live-dot ${vivo ? '' : 'off'}`} aria-hidden />
      <span className={`conn ${vivo ? 'green' : 'amber'}`}>
        {vivo ? <Radio aria-hidden /> : <WifiOff aria-hidden />}
        {vivo ? 'En vivo' : 'Reconectando…'}
      </span>
      {mostrarActualizacion && ultimaActualizacion > 0 && (
        <>
          <span className="muted">·</span>
          <span id="update">Actualizado {fmtHoraSeg(ultimaActualizacion)}</span>
        </>
      )}
    </div>
  );
}
